import publicRoute from "./publicRoute";
import appsRoute from "./appsRoute";

export const publicRoutes = [...publicRoute];
export const protectedRoutes = [...appsRoute];
